import React from 'react'
import styled from 'styled-components'
import { QRCode } from 'react-qrcode-logo'
import { Block, Button } from '@mote/ui'
import { useTrackMutation } from '@mote/api'

export const QrCodeDisplay = ({
  moteId,
  url,
  logoImage,
  renderFor = 'extension'
}) => {
  const containerRef = React.useRef(null)
  const { mutate: track } = useTrackMutation()

  function saveImage() {
    const canvas = containerRef.current.querySelector('canvas')

    if (!canvas) return

    const link = document.createElement('a')
    link.download = `mote-qr-${moteId}.png`
    link.href = canvas.toDataURL('image/png')
    link.click()

    track({
      variables: {
        event: 'Mote Share Action Taken',
        action: 'QR-image-saved'
      }
    })
  }

  return (
    <Root
      align='center'
      margin={renderFor === 'extension' ? '47px 0 0 0' : '0 0 0 0'}
      gap={renderFor === 'extension' ? 31 : 13}
      ref={containerRef}
    >
      <QRCode
        size={135}
        value={url}
        logoImage={logoImage}
        logoHeight={32}
        logoWidth={32}
      />
      <Button text='Save image' onClick={saveImage} />
    </Root>
  )
}

const Root = styled(Block)``
